export default {"src":"/_next/static/media/Ulcers.f38c24a9.svg","height":51,"width":51,"blurWidth":0,"blurHeight":0};